import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<
  Theme,
  {
    cardFontColor: string;
    cardBackgroundImage: string;
  }
>(theme => ({
  inherit: {
    color: 'inherit !important',
    backgroundImage: 'inherit !important',
  },
  header: {
    color: ({ cardFontColor }) => `${cardFontColor} !important`,
    backgroundImage: ({ cardBackgroundImage }) =>
      `${cardBackgroundImage} !important`,
    padding: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(0, 2),
  },
  tag:
    theme.palette.type === 'dark'
      ? {}
      : {
          backgroundColor: 'rgba(204, 230, 255, 0.2)',
          color: '#0073e6',
          borderColor: '#cce5ff',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
  link:
    theme.palette.type === 'dark'
      ? { cursor: 'pointer' }
      : {
          backgroundColor: 'inherit',
          color: '#0073e6',
          borderColor: '#cce5ff',
          borderWidth: '1px',
          borderStyle: 'solid',
          cursor: 'pointer',
        },
}));
